import { api } from "@/lib/apiClient";

export const LAYOUT_FULL_WIDTH_STORAGE_KEY = "eh:layout-full-width";
export const LAYOUT_FULL_WIDTH_CHANGE_EVENT = "eh:layout-full-width-change";

export function readLayoutFullWidthLocal(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(LAYOUT_FULL_WIDTH_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function applyLayoutFullWidthLocally(fullWidth: boolean): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(LAYOUT_FULL_WIDTH_STORAGE_KEY, fullWidth ? "1" : "0");
  } catch {
    // ignore (private mode etc.)
  }
  window.dispatchEvent(
    new CustomEvent(LAYOUT_FULL_WIDTH_CHANGE_EVENT, { detail: { fullWidth } }),
  );
}

export async function fetchLayoutPreferenceFromServer(): Promise<{
  fullWidth: boolean;
  hasPreference: boolean;
}> {
  const data = await api.get<{ full_width?: unknown; has_preference?: unknown }>(
    "/me/layout-preference",
  );
  return {
    fullWidth: data?.full_width === true,
    hasPreference: data?.has_preference === true,
  };
}

export async function persistLayoutPreferenceToServer(fullWidth: boolean): Promise<boolean> {
  const data = await api.put<{ full_width?: unknown }>("/me/layout-preference", {
    full_width: fullWidth,
  });
  return data?.full_width === true ? true : fullWidth;
}

export async function saveLayoutFullWidth(next: boolean): Promise<void> {
  applyLayoutFullWidthLocally(next);
  try {
    const saved = await persistLayoutPreferenceToServer(next);
    applyLayoutFullWidthLocally(saved);
  } catch {
    // Lokale Auswahl bleibt aktiv; Server-Sync beim nächsten Laden.
  }
}

export async function bootstrapLayoutPreferenceFromServer(): Promise<boolean> {
  try {
    const { fullWidth, hasPreference } = await fetchLayoutPreferenceFromServer();
    if (!hasPreference) {
      const local = readLayoutFullWidthLocal();
      const saved = await persistLayoutPreferenceToServer(local);
      applyLayoutFullWidthLocally(saved);
      return saved;
    }
    applyLayoutFullWidthLocally(fullWidth);
    return fullWidth;
  } catch {
    return readLayoutFullWidthLocal();
  }
}
